var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

var Button = function Button(_ref) {
  var _classnames;

  var primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      active = _ref.active,
      submitting = _ref.submitting,
      component = _ref.component,
      compact = _ref.compact,
      props = _objectWithoutProperties(_ref, ["primary", "secondary", "tertiary", "children", "className", "icon", "active", "submitting", "component", "compact"]);

  var baseClass = "button";
  var modifier = void 0;

  if (primary) {
    modifier = "primary";
  } else if (secondary) {
    modifier = "secondary";
  } else if (tertiary) {
    modifier = "tertiary";
  }

  var componentCls = classnames(baseClass, (_classnames = {}, _classnames[baseClass + "--" + modifier] = modifier, _classnames[baseClass + "--icon"] = icon, _classnames[baseClass + "--active"] = active, _classnames[baseClass + "--submitting"] = submitting, _classnames[baseClass + "--compact"] = compact, _classnames), className);

  var Element = component || "button";

  return React.createElement(
    Element,
    _extends({}, props, { className: componentCls }),
    React.createElement(
      "span",
      null,
      children
    ),
    submitting && React.createElement("div", { className: baseClass + "__loader" })
  );
};

Button.propTypes = process.env.NODE_ENV !== "production" ? {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  icon: PropTypes.bool,
  submitting: PropTypes.bool,
  active: PropTypes.bool,
  className: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  compact: PropTypes.bool
} : {};

export default Button;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/button/button.js
// module id = null
// module chunks = 